import { put, takeEvery } from 'redux-saga/effects';
import { call } from 'typed-redux-saga';
import { LogisticsActionKeys, UpdateWarehouseGroup } from '..';
import { lookupActionCreators } from '../../lookups';
import { processMessages, showFailedRequestDialog } from '../../sagaUtils';
import { uiActionCreators } from '../../ui';
import { updateWarehouseGroup } from '../logisticsApi';

function* updateWarehouseGroupSaga(action: UpdateWarehouseGroup) {
  yield put(uiActionCreators.showSpinnerDialog());
  const response = yield* call(updateWarehouseGroup, action.payload);

  if (response.requestFailed) {
    yield showFailedRequestDialog(response);
  } else if (response.value) {
    yield processMessages(response.value);

    if (response.value.value) {
      yield put(
        lookupActionCreators.setLookups({ partial: true, payload: { warehouseGroups: [response.value.value] } })
      );
    }
  }

  yield put(uiActionCreators.hideSpinnerDialog());
}

export function* watchUpdateWarehouseGroup() {
  yield takeEvery(LogisticsActionKeys.UPDATE_WAREHOUSE_GROUP, updateWarehouseGroupSaga);
}
